import PanzoomHandler from "./panzoom.js";

function getScrollContainersInfo() {
    const list = [];
    const elements = document.querySelectorAll('.fi-modal-window-ctn, .fi-modal-window');
    elements.forEach((el) => {
        if (el.scrollHeight > el.clientHeight || el.scrollTop > 0) {
            list.push({ element: el, scrollTop: el.scrollTop });
        }
    });
    list.push({ element: window, scrollTop: window.scrollY || document.documentElement.scrollTop });
    return list;
}

function restoreScrollContainers(list) {
    if (!list || !list.length) return;
    list.forEach((item) => {
        if (item.element === window) {
            window.scrollTo({ top: item.scrollTop, behavior: 'instant' });
        } else if (item.element && item.element.isConnected) {
            item.element.scrollTop = item.scrollTop;
        }
    });
}

/**
 * Alpine.js store for the lightbox
 * IDEs will/may not recognize Alpine as it is bundled by default with Livewire instead of being a separate package
 */
Alpine.store('attachments', {
    isOpen: false,
    savedScrolls: [],
    initialImageUrl: null,
    activeImageUrl: null,

    modalOpened() {
        this.isOpen = true;
        this.savedScrolls = getScrollContainersInfo();

        const lightbox = document.getElementById('lightbox');
        if (!lightbox) return;

        const navLeft = lightbox.querySelector('.nav-left');
        const navRight = lightbox.querySelector('.nav-right');
        const orderImages = Object.values(JSON.parse(lightbox.dataset.images || '{}'));
        const currentImage = lightbox.querySelector(".lightbox-image");

        if (currentImage) {
            this.initialImageUrl = currentImage.src;
            this.activeImageUrl = currentImage.src;

            PanzoomHandler.init(currentImage);
            PanzoomHandler.reset(currentImage);
            initPanzoomEvents();
        }

        if (orderImages.length > 1) {
            document.addEventListener('keyup', startLightbox);
            navLeft?.addEventListener('click', startLightbox);
            navRight?.addEventListener('click', startLightbox);

            navLeft?.classList.remove('hidden');
            navRight?.classList.remove('hidden');

            setTimeout(() => {
                if (orderImages[orderImages.length - 1] === lightbox.querySelector('.lightbox-image')?.src) {
                    enableNavButton(navLeft);
                    disableNavButton(navRight);
                }

                if (orderImages[0] === lightbox.querySelector('.lightbox-image')?.src) {
                    enableNavButton(navRight);
                    disableNavButton(navLeft);
                }
            }, 250);
        }
    },

    modalClosed() {
        if (!this.isOpen) return;
        this.isOpen = false;

        const lightbox = document.getElementById('lightbox');
        if (lightbox) {
            const navLeft = lightbox.querySelector('.nav-left');
            const navRight = lightbox.querySelector('.nav-right');

            document.removeEventListener('keyup', startLightbox);
            navLeft?.removeEventListener('click', startLightbox);
            navRight?.removeEventListener('click', startLightbox);

            navLeft?.classList.add('hidden');
            navRight?.classList.add('hidden');
        }

        PanzoomHandler.destroy();

        const savedScrolls = this.savedScrolls;
        const activeUrl = this.activeImageUrl;
        const initialUrl = this.initialImageUrl;

        const restore = () => {
            restoreScrollContainers(savedScrolls);

            if (activeUrl) {
                const matchingThumb = document.querySelector(`img[data-url="${activeUrl}"]`);
                if (matchingThumb) {
                    matchingThumb.focus({ preventScroll: true });
                    if (activeUrl !== initialUrl) {
                        matchingThumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
                    }
                }
            }
        };

        restore();
        requestAnimationFrame(restore);
        setTimeout(restore, 50);
        setTimeout(restore, 150);
    },

    selectAll(type = '') {
        document.querySelectorAll(`.${type}selectedAttachments`)
            .forEach((checkbox) => checkbox.checked === false ? checkbox.click() : null);
    }
});

/**
 * Start the lightbox
 * @param e
 */
function startLightbox(e) {
    const lightbox = document.getElementById('lightbox');
    if (!lightbox) return;

    const navLeft = lightbox.querySelector('.nav-left');
    const navRight = lightbox.querySelector('.nav-right');
    const orderImages = Object.values(JSON.parse(lightbox.dataset.images || '{}'));
    const currentImage = lightbox.querySelector('.lightbox-image');
    if (!currentImage) return;

    const currentImageIndex = orderImages.findIndex((image) => image === currentImage.src);

    let newImageIndex = 0;

    if (e.key === 'ArrowLeft' || e.target.classList.contains('nav-left')) {
        if (currentImageIndex > 0) {
            newImageIndex = currentImageIndex - 1;
            currentImage.src = orderImages[newImageIndex];
            Alpine.store('attachments').activeImageUrl = orderImages[newImageIndex];
            PanzoomHandler.reset(currentImage);
        }

        if (newImageIndex === 0) {
            disableNavButton(navLeft);
        }

        if (navRight.classList.contains('opacity-50')) {
            enableNavButton(navRight);
        }
    }

    if (e.key === 'ArrowRight' || e.target.classList.contains('nav-right')) {
        if (currentImageIndex < orderImages.length - 1) {
            newImageIndex = currentImageIndex + 1;
            currentImage.src = orderImages[newImageIndex];
            Alpine.store('attachments').activeImageUrl = orderImages[newImageIndex];
            PanzoomHandler.reset(currentImage);
        }

        if (newImageIndex === orderImages.length - 1) {
            disableNavButton(navRight);
        }

        if (navLeft.classList.contains('opacity-50')) {
            enableNavButton(navLeft);
        }
    }
}

function enableNavButton(navButton) {
    navButton.classList.remove('opacity-50');
    navButton.classList.add('cursor-pointer');
}

function disableNavButton(navButton) {
    navButton.classList.add('opacity-50');
    navButton.classList.remove('cursor-pointer');
}

function initPanzoomEvents() {
    const zoomInButton = document.getElementById("zoom-in");
    const zoomOutButton = document.getElementById("zoom-out");
    const rotateLeftButton = document.getElementById("rotate-left");
    const rotateRightButton = document.getElementById("rotate-right");

    const currentImage = document.querySelector(".lightbox-image");

    zoomInButton?.addEventListener("click", () => PanzoomHandler.zoomIn(currentImage));
    zoomOutButton?.addEventListener("click", () => PanzoomHandler.zoomOut(currentImage));
    rotateLeftButton?.addEventListener("click", () => PanzoomHandler.rotateLeft(currentImage));
    rotateRightButton?.addEventListener("click", () => PanzoomHandler.rotateRight(currentImage));
}
